// export const config = {
//     apiKey: "AIzaSyBGOXSLYJwZZD0VvtqnRTkz6YJzaEHveMQ",
//     authDomain: "cms-services-9c5cf.firebaseapp.com",
//     databaseURL: "https://cms-services-9c5cf.firebaseio.com",
//     projectId: "cms-services-9c5cf",
//     storageBucket: "cms-services-9c5cf.appspot.com",
//     messagingSenderId: "587286813667"
// };

export const config = {
    apiKey: "AIzaSyAFp5x3U6dgO9IxXi0d7x7nOwH2rR-VDPE",
    authDomain: "interactive-coc.firebaseapp.com",
    databaseURL: "https://interactive-coc.firebaseio.com",
    projectId: "interactive-coc",
    storageBucket: "gs://interactive-coc.appspot.com",
    messagingSenderId: "637926966965"
}

 